export const NCAA_TEAMS: {
  shortName: string;
  division: string;
}[] = [
  {
    shortName: 'Alabama',
    division: 'Southeastern',
  },
  {
    shortName: 'Alabama A&M',
    division: 'SWAC',
  },
  {
    shortName: 'Alabama St.',
    division: 'SWAC',
  },
  {
    shortName: 'Auburn',
    division: 'Southeastern',
  },
  {
    shortName: 'Jacksonville',
    division: 'Conference USA',
  },
  {
    shortName: 'North Alabama',
    division: 'ASUN',
  },
  {
    shortName: 'Samford',
    division: 'Southern',
  },
  {
    shortName: 'South Ala.',
    division: 'Sun Belt',
  },
  {
    shortName: 'Troy',
    division: 'Sun Belt',
  },
  {
    shortName: 'UAB',
    division: 'The American',
  },
  {
    shortName: 'Arizona',
    division: 'Big 12',
  },
  {
    shortName: 'Arizona St.',
    division: 'Big 12',
  },
  {
    shortName: 'Grand Canyon',
    division: 'Mountain West',
  },
  {
    shortName: 'Ark. Pine Bluff',
    division: 'SWAC',
  },
  {
    shortName: 'Arkansas',
    division: 'Southeastern',
  },
  {
    shortName: 'Arkansas St.',
    division: 'Sun Belt',
  },
  {
    shortName: 'Central Arkansas',
    division: 'ASUN',
  },
  {
    shortName: 'Little-Rock',
    division: 'Ohio Valley',
  },
  {
    shortName: 'Cal Baptist',
    division: 'Western Athletic',
  },
  {
    shortName: 'Cal Poly',
    division: 'Big West',
  },
  {
    shortName: 'Cal St. Fullerton',
    division: 'Big West',
  },
  {
    shortName: 'Cal St. Northridge',
    division: 'Big West',
  },
  {
    shortName: 'California',
    division: 'Atlantic Coast',
  },
  {
    shortName: 'CSU Bakersfield',
    division: 'Big West',
  },
  {
    shortName: 'Fresno St.',
    division: 'Mountain West',
  },
  {
    shortName: 'Long Beach St.',
    division: 'Big West',
  },
  {
    shortName: 'Loyola Marymount',
    division: 'West Coast',
  },
  {
    shortName: 'Pacific',
    division: 'West Coast',
  },
  {
    shortName: 'Pepperdine',
    division: 'West Coast',
  },
  {
    shortName: 'Sacramento St.',
    division: 'Western Athletic',
  },
  {
    shortName: "Saint-Mary's (CA)",
    division: 'West Coast',
  },
  {
    shortName: 'San Diego',
    division: 'West Coast',
  },
  {
    shortName: 'San Diego St.',
    division: 'Mountain West',
  },
  {
    shortName: 'San Francisco',
    division: 'West Coast',
  },
  {
    shortName: 'San Jose St.',
    division: 'Mountain West',
  },
  {
    shortName: 'Santa Clara',
    division: 'West Coast',
  },
  {
    shortName: 'Southern California',
    division: 'Big Ten',
  },
  {
    shortName: 'Stanford',
    division: 'Atlantic Coast',
  },
  {
    shortName: 'UC Davis',
    division: 'Big West',
  },
  {
    shortName: 'UC Irvine',
    division: 'Big West',
  },
  {
    shortName: 'UC Riverside',
    division: 'Big West',
  },
  {
    shortName: 'UC San Diego',
    division: 'Big West',
  },
  {
    shortName: 'UC Santa Barbara',
    division: 'Big West',
  },
  {
    shortName: 'UCLA',
    division: 'Big Ten',
  },
  {
    shortName: 'Air Force',
    division: 'Mountain West',
  },
  {
    shortName: 'Northern Colorado',
    division: 'The Summit',
  },
  {
    shortName: 'Central Connecticut St.',
    division: 'Northeast',
  },
  {
    shortName: 'Connecticut',
    division: 'Big East',
  },
  {
    shortName: 'Fairfield',
    division: 'MAAC',
  },
  {
    shortName: 'Quinnipiac',
    division: 'MAAC',
  },
  {
    shortName: 'Sacred Heart',
    division: 'MAAC',
  },
  {
    shortName: 'Yale',
    division: 'Ivy League',
  },
  {
    shortName: 'Delaware',
    division: 'Conference USA',
  },
  {
    shortName: 'Delaware St.',
    division: 'Northeast',
  },
  {
    shortName: 'Bethune–Cookman',
    division: 'SWAC',
  },
  {
    shortName: 'FGCU',
    division: 'ASUN',
  },
  {
    shortName: 'FIU',
    division: 'Conference USA',
  },
  {
    shortName: 'Florida',
    division: 'Southeastern',
  },
  {
    shortName: 'Florida A&M',
    division: 'SWAC',
  },
  {
    shortName: 'Florida Atlantic',
    division: 'The American',
  },
  {
    shortName: 'Florida St.',
    division: 'Atlantic Coast',
  },
  {
    shortName: 'Jacksonville',
    division: 'ASUN',
  },
  {
    shortName: 'Miami',
    division: 'Atlantic Coast',
  },
  {
    shortName: 'North Florida',
    division: 'ASUN',
  },
  {
    shortName: 'South Fla.',
    division: 'The American',
  },
  {
    shortName: 'Stetson',
    division: 'ASUN',
  },
  {
    shortName: 'UCF',
    division: 'Big 12',
  },
  {
    shortName: 'Georgia',
    division: 'Southeastern',
  },
  {
    shortName: 'Georgia Southern',
    division: 'Sun Belt',
  },
  {
    shortName: 'Georgia St.',
    division: 'Sun Belt',
  },
  {
    shortName: 'Georgia Tech',
    division: 'Atlantic Coast',
  },
  {
    shortName: 'Kennesaw',
    division: 'Conference USA',
  },
  {
    shortName: 'Mercer',
    division: 'Southern',
  },
  {
    shortName: 'Hawaiʻi',
    division: 'Big West',
  },
  {
    shortName: 'Bradley',
    division: 'Missouri Valley',
  },
  {
    shortName: 'Eastern Ill.',
    division: 'Ohio Valley',
  },
  {
    shortName: 'Illinois',
    division: 'Big Ten',
  },
  {
    shortName: 'Illinois',
    division: 'Missouri Valley',
  },
  {
    shortName: 'Illinois St.',
    division: 'Missouri Valley',
  },
  {
    shortName: 'Northern Ill.',
    division: 'Mid-American',
  },
  {
    shortName: 'Northwestern',
    division: 'Big Ten',
  },
  {
    shortName: 'SIUE',
    division: 'Ohio Valley',
  },
  {
    shortName: 'Southern Ill.',
    division: 'Missouri Valley',
  },
  {
    shortName: 'Western Ill.',
    division: 'Ohio Valley',
  },
  {
    shortName: 'Ball St.',
    division: 'Mid-American',
  },
  {
    shortName: 'Butler',
    division: 'Big East',
  },
  {
    shortName: 'Evansville',
    division: 'Missouri Valley',
  },
  {
    shortName: 'Indiana',
    division: 'Big Ten',
  },
  {
    shortName: 'Indiana St.',
    division: 'Missouri Valley',
  },
  {
    shortName: 'Notre Dame',
    division: 'Atlantic Coast',
  },
  {
    shortName: 'Purdue',
    division: 'Big Ten',
  },
  {
    shortName: 'Purdue University Fort Wayne',
    division: 'Horizon League',
  },
  {
    shortName: 'Southern Ind.',
    division: 'Ohio Valley',
  },
  {
    shortName: 'Valparaiso',
    division: 'Missouri Valley',
  },
  {
    shortName: 'Iowa',
    division: 'Big Ten',
  },
  {
    shortName: 'Kansas',
    division: 'Big 12',
  },
  {
    shortName: 'Kansas St.',
    division: 'Big 12',
  },
  {
    shortName: 'Wichita St.',
    division: 'The American',
  },
  {
    shortName: 'Bellarmine',
    division: 'ASUN',
  },
  {
    shortName: 'Eastern Kentucky',
    division: 'ASUN',
  },
  {
    shortName: 'Kentucky',
    division: 'Southeastern',
  },
  {
    shortName: 'Louisville',
    division: 'Atlantic Coast',
  },
  {
    shortName: 'Morehead St.',
    division: 'Ohio Valley',
  },
  {
    shortName: 'Murray St.',
    division: 'Missouri Valley',
  },
  {
    shortName: 'Northern Ky.',
    division: 'Horizon League',
  },
  {
    shortName: 'WKU',
    division: 'Conference USA',
  },
  {
    shortName: 'Grambling St.',
    division: 'SWAC',
  },
  {
    shortName: 'La.-Lafayette',
    division: 'Sun Belt',
  },
  {
    shortName: 'La.-Monroe',
    division: 'Sun Belt',
  },
  {
    shortName: 'Louisiana',
    division: 'Conference USA',
  },
  {
    shortName: 'LSU',
    division: 'Southeastern',
  },
  {
    shortName: 'McNeese St.',
    division: 'Southland',
  },
  {
    shortName: 'New Orleans',
    division: 'Southland',
  },
  {
    shortName: 'Nicholls St.',
    division: 'Southland',
  },
  {
    shortName: 'Northwestern St.',
    division: 'Southland',
  },
  {
    shortName: 'Southeastern La.',
    division: 'Southland',
  },
  {
    shortName: 'Southern',
    division: 'SWAC',
  },
  {
    shortName: 'Tulane',
    division: 'The American',
  },
  {
    shortName: 'Maine',
    division: 'America East',
  },
  {
    shortName: 'Coppin St.',
    division: 'Northeast',
  },
  {
    shortName: 'Maryland',
    division: 'Big Ten',
  },
  {
    shortName: 'Maryland-Baltimore-County',
    division: 'America East',
  },
  {
    shortName: 'Md.-East. Shore',
    division: 'Northeast',
  },
  {
    shortName: 'Mount',
    division: 'MAAC',
  },
  {
    shortName: 'Navy',
    division: 'Patriot League',
  },
  {
    shortName: 'Towson',
    division: 'Coastal Athletic',
  },
  {
    shortName: 'Boston College',
    division: 'Atlantic Coast',
  },
  {
    shortName: 'Harvard',
    division: 'Ivy League',
  },
  {
    shortName: 'Holy Cross',
    division: 'Patriot League',
  },
  {
    shortName: 'Mass-Amherst',
    division: 'Mid-American',
  },
  {
    shortName: 'Mass.-Lowell',
    division: 'America East',
  },
  {
    shortName: 'Merrimack',
    division: 'MAAC',
  },
  {
    shortName: 'Northeastern',
    division: 'Coastal Athletic',
  },
  {
    shortName: 'Stonehill',
    division: 'Northeast',
  },
  {
    shortName: 'Central Michigan',
    division: 'Mid-American',
  },
  {
    shortName: 'Eastern Michigan',
    division: 'Mid-American',
  },
  {
    shortName: 'Michigan',
    division: 'Big Ten',
  },
  {
    shortName: 'Michigan St.',
    division: 'Big Ten',
  },
  {
    shortName: 'Oakland',
    division: 'Horizon League',
  },
  {
    shortName: 'Western Mich.',
    division: 'Mid-American',
  },
  {
    shortName: 'Minnesota',
    division: 'Big Ten',
  },
  {
    shortName: 'St. Thomas',
    division: 'The Summit',
  },
  {
    shortName: 'Alcorn St.',
    division: 'SWAC',
  },
  {
    shortName: 'Jackson St.',
    division: 'SWAC',
  },
  {
    shortName: 'Mississippi St.',
    division: 'Southeastern',
  },
  {
    shortName: 'Mississippi Val.',
    division: 'SWAC',
  },
  {
    shortName: 'Ole Miss',
    division: 'Southeastern',
  },
  {
    shortName: 'Southern Miss.',
    division: 'Sun Belt',
  },
  {
    shortName: 'Lindenwood',
    division: 'Ohio Valley',
  },
  {
    shortName: 'Missouri',
    division: 'Southeastern',
  },
  {
    shortName: 'Missouri St.',
    division: 'Conference USA',
  },
  {
    shortName: 'Saint Louis',
    division: 'Atlantic 10',
  },
  {
    shortName: 'Southeast Miss.',
    division: 'Ohio Valley',
  },
  {
    shortName: 'Creighton',
    division: 'Big East',
  },
  {
    shortName: 'Nebraska',
    division: 'Big Ten',
  },
  {
    shortName: 'Omaha',
    division: 'The Summit',
  },
  {
    shortName: 'Nevada',
    division: 'Mountain West',
  },
  {
    shortName: 'UNLV',
    division: 'Mountain West',
  },
  {
    shortName: 'Dartmouth',
    division: 'Ivy League',
  },
  {
    shortName: 'FDU-Florham',
    division: 'Northeast',
  },
  {
    shortName: 'Monmouth',
    division: 'Coastal Athletic',
  },
  {
    shortName: 'New-Jersey-Tech',
    division: 'America East',
  },
  {
    shortName: 'Princeton',
    division: 'Ivy League',
  },
  {
    shortName: 'Rider',
    division: 'MAAC',
  },
  {
    shortName: 'Rutgers',
    division: 'Big Ten',
  },
  {
    shortName: "Saint Peter's",
    division: 'MAAC',
  },
  {
    shortName: 'Seton',
    division: 'Big East',
  },
  {
    shortName: 'New Mexico',
    division: 'Mountain West',
  },
  {
    shortName: 'New Mexico St.',
    division: 'Conference USA',
  },
  {
    shortName: 'Albany (NY)',
    division: 'America East',
  },
  {
    shortName: 'Army',
    division: 'Patriot League',
  },
  {
    shortName: 'Binghamton',
    division: 'America East',
  },
  {
    shortName: 'Canisius',
    division: 'MAAC',
  },
  {
    shortName: 'Columbia',
    division: 'Ivy League',
  },
  {
    shortName: 'Cornell',
    division: 'Ivy League',
  },
  {
    shortName: 'Fordham',
    division: 'Atlantic 10',
  },
  {
    shortName: 'Hofstra',
    division: 'Coastal Athletic',
  },
  {
    shortName: 'Iona',
    division: 'MAAC',
  },
  {
    shortName: 'LIU',
    division: 'Northeast',
  },
  {
    shortName: 'Manhattan',
    division: 'MAAC',
  },
  {
    shortName: 'Marist',
    division: 'MAAC',
  },
  {
    shortName: 'Niagara',
    division: 'MAAC',
  },
  {
    shortName: 'Siena',
    division: 'MAAC',
  },
  {
    shortName: 'St. Bonaventure',
    division: 'Atlantic 10',
  },
  {
    shortName: "St. John's",
    division: 'Big East',
  },
  {
    shortName: 'Stony Brook',
    division: 'Coastal Athletic',
  },
  {
    shortName: 'Wagner',
    division: 'Northeast',
  },
  {
    shortName: 'Appalachian St.',
    division: 'Sun Belt',
  },
  {
    shortName: 'Campbell',
    division: 'Coastal Athletic',
  },
  {
    shortName: 'Charlotte',
    division: 'The American',
  },
  {
    shortName: 'Davidson',
    division: 'Atlantic 10',
  },
  {
    shortName: 'Duke',
    division: 'Atlantic Coast',
  },
  {
    shortName: 'East Carolina',
    division: 'The American',
  },
  {
    shortName: 'Elon',
    division: 'Coastal Athletic',
  },
  {
    shortName: 'Gardner–Webb',
    division: 'Big South',
  },
  {
    shortName: 'High Point',
    division: 'Big South',
  },
  {
    shortName: 'North Carolina',
    division: 'Atlantic Coast',
  },
  {
    shortName: 'North Carolina A&T',
    division: 'Coastal Athletic',
  },
  {
    shortName: 'North Carolina St.',
    division: 'Atlantic Coast',
  },
  {
    shortName: 'Queens (NC)',
    division: 'ASUN',
  },
  {
    shortName: 'UNC Asheville',
    division: 'Big South',
  },
  {
    shortName: 'UNC Greensboro',
    division: 'Southern',
  },
  {
    shortName: 'UNCW',
    division: 'Coastal Athletic',
  },
  {
    shortName: 'Wake Forest',
    division: 'Atlantic Coast',
  },
  {
    shortName: 'Western Caro.',
    division: 'Southern',
  },
  {
    shortName: 'North Dakota St.',
    division: 'The Summit',
  },
  {
    shortName: 'Akron',
    division: 'Mid-American',
  },
  {
    shortName: 'Bowling Green',
    division: 'Mid-American',
  },
  {
    shortName: 'Cincinnati',
    division: 'Big 12',
  },
  {
    shortName: 'Dayton',
    division: 'Atlantic 10',
  },
  {
    shortName: 'Kent St.',
    division: 'Mid-American',
  },
  {
    shortName: 'Miami (OH)',
    division: 'Mid-American',
  },
  {
    shortName: 'Ohio',
    division: 'Big Ten',
  },
  {
    shortName: 'Ohio',
    division: 'Mid-American',
  },
  {
    shortName: 'Toledo',
    division: 'Mid-American',
  },
  {
    shortName: 'Wright St.',
    division: 'Horizon League',
  },
  {
    shortName: 'Xavier',
    division: 'Big East',
  },
  {
    shortName: 'Youngstown St.',
    division: 'Horizon League',
  },
  {
    shortName: 'Oklahoma',
    division: 'Southeastern',
  },
  {
    shortName: 'Oklahoma St.',
    division: 'Big 12',
  },
  {
    shortName: 'Oral Roberts',
    division: 'The Summit',
  },
  {
    shortName: 'Oregon',
    division: 'Big Ten',
  },
  {
    shortName: 'Oregon St.',
    division: 'Independent',
  },
  {
    shortName: 'Portland',
    division: 'West Coast',
  },
  {
    shortName: 'Bucknell',
    division: 'Patriot League',
  },
  {
    shortName: 'La Salle',
    division: 'Atlantic 10',
  },
  {
    shortName: 'Lafayette',
    division: 'Patriot League',
  },
  {
    shortName: 'Lehigh',
    division: 'Patriot League',
  },
  {
    shortName: 'Penn',
    division: 'Ivy League',
  },
  {
    shortName: 'Penn St.',
    division: 'Big Ten',
  },
  {
    shortName: 'Pitt',
    division: 'Atlantic Coast',
  },
  {
    shortName: "Saint Joseph's",
    division: 'Atlantic 10',
  },
  {
    shortName: 'Villanova',
    division: 'Big East',
  },
  {
    shortName: 'Brown',
    division: 'Ivy League',
  },
  {
    shortName: 'Bryant',
    division: 'America East',
  },
  {
    shortName: 'Rhode',
    division: 'Atlantic 10',
  },
  {
    shortName: 'Charleston',
    division: 'Coastal Athletic',
  },
  {
    shortName: 'Charleston Southern',
    division: 'Big South',
  },
  {
    shortName: 'Citadel',
    division: 'Southern',
  },
  {
    shortName: 'Clemson',
    division: 'Atlantic Coast',
  },
  {
    shortName: 'Coastal Carolina',
    division: 'Sun Belt',
  },
  {
    shortName: 'Presbyterian',
    division: 'Big South',
  },
  {
    shortName: 'South Carolina',
    division: 'Southeastern',
  },
  {
    shortName: 'South Carolina Upstate',
    division: 'Big South',
  },
  {
    shortName: 'Winthrop',
    division: 'Big South',
  },
  {
    shortName: 'Wofford',
    division: 'Southern',
  },
  {
    shortName: 'South Dakota St.',
    division: 'The Summit',
  },
  {
    shortName: 'Austin Peay',
    division: 'ASUN',
  },
  {
    shortName: 'Belmont',
    division: 'Missouri Valley',
  },
  {
    shortName: 'ETSU',
    division: 'Southern',
  },
  {
    shortName: 'Lipscomb',
    division: 'ASUN',
  },
  {
    shortName: 'Memphis',
    division: 'The American',
  },
  {
    shortName: 'Middle Tennessee St.',
    division: 'Conference USA',
  },
  {
    shortName: 'Tenn-Martin',
    division: 'Ohio Valley',
  },
  {
    shortName: 'Tennessee',
    division: 'Southeastern',
  },
  {
    shortName: 'Tennessee Tech',
    division: 'Ohio Valley',
  },
  {
    shortName: 'Vanderbilt',
    division: 'Southeastern',
  },
  {
    shortName: 'Abilene Christian',
    division: 'Western Athletic',
  },
  {
    shortName: 'Baylor',
    division: 'Big 12',
  },
  {
    shortName: 'Dallas Baptist',
    division: 'Conference USA',
  },
  {
    shortName: 'Houston',
    division: 'Big 12',
  },
  {
    shortName: 'Houston Christian',
    division: 'Southland',
  },
  {
    shortName: 'Lamar',
    division: 'Southland',
  },
  {
    shortName: 'Prairie View',
    division: 'SWAC',
  },
  {
    shortName: 'Rice',
    division: 'The American',
  },
  {
    shortName: 'Sam Houston St.',
    division: 'Conference USA',
  },
  {
    shortName: 'Stephen F. Austin',
    division: 'Southland',
  },
  {
    shortName: 'Tarleton St.',
    division: 'Western Athletic',
  },
  {
    shortName: 'TCU',
    division: 'Big 12',
  },
  {
    shortName: 'Texas',
    division: 'Southeastern',
  },
  {
    shortName: 'Texas A&M',
    division: 'Southeastern',
  },
  {
    shortName: 'Texas at Arlington',
    division: 'Western Athletic',
  },
  {
    shortName: 'Texas at San Antonio',
    division: 'The American',
  },
  {
    shortName: 'Texas Rio Grande Valley',
    division: 'Southland',
  },
  {
    shortName: 'Texas Southern',
    division: 'SWAC',
  },
  {
    shortName: 'Texas St.',
    division: 'Sun Belt',
  },
  {
    shortName: 'Texas Tech',
    division: 'Big 12',
  },
  {
    shortName: 'Texas-Am-Corpus',
    division: 'Southland',
  },
  {
    shortName: 'UIW',
    division: 'Southland',
  },
  {
    shortName: 'BYU',
    division: 'Big 12',
  },
  {
    shortName: 'Utah',
    division: 'Big 12',
  },
  {
    shortName: 'Utah Valley',
    division: 'Western Athletic',
  },
  {
    shortName: 'George Mason',
    division: 'Atlantic 10',
  },
  {
    shortName: 'James Madison',
    division: 'Sun Belt',
  },
  {
    shortName: 'Liberty',
    division: 'Conference USA',
  },
  {
    shortName: 'Longwood',
    division: 'Big South',
  },
  {
    shortName: 'Norfolk St.',
    division: 'Northeast',
  },
  {
    shortName: 'Old Dominion',
    division: 'Sun Belt',
  },
  {
    shortName: 'Radford',
    division: 'Big South',
  },
  {
    shortName: 'Richmond',
    division: 'Atlantic 10',
  },
  {
    shortName: 'VCU',
    division: 'Atlantic 10',
  },
  {
    shortName: 'Virginia',
    division: 'Atlantic Coast',
  },
  {
    shortName: 'Virginia Tech',
    division: 'Atlantic Coast',
  },
  {
    shortName: 'VMI',
    division: 'Southern',
  },
  {
    shortName: 'William & Mary',
    division: 'Coastal Athletic',
  },
  {
    shortName: 'Gonzaga',
    division: 'West Coast',
  },
  {
    shortName: 'Seattle',
    division: 'West Coast',
  },
  {
    shortName: 'Washington',
    division: 'Big Ten',
  },
  {
    shortName: 'Washington St.',
    division: 'Mountain West',
  },
  {
    shortName: 'George Washington',
    division: 'Atlantic 10',
  },
  {
    shortName: 'Georgetown',
    division: 'Big East',
  },
  {
    shortName: 'Marshall',
    division: 'Sun Belt',
  },
  {
    shortName: 'West Virginia',
    division: 'Big 12',
  },
  {
    shortName: 'Milwaukee',
    division: 'Horizon League',
  },
];
